// packages
import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { map } from "rxjs/operators";

// services
import { ProfileService } from "src/app/api/profile.service";

export const LegacyVerificationGuard: CanActivateFn = () => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  return profileService
    .isIndividualVerificationEnabled()
    .pipe(map((enabled) => (enabled ? router.createUrlTree(["/kyc"]) : true)));
};
